import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CommandBar, } from '@fluentui/react';
import { MicrosoftLogo } from './MicrosoftLogo';
import { AppErrorBoundary } from '../AppErrorBoundary';
import { DefaultMeControl } from './builtInItem/DefaultMeControl';
import { useAppbarCommandBarStyles } from './useAppbarCommandBarStyles';
import { useAppBarNearItems } from './useAppBarNearItems';
import { useAppBarFarItems } from './useAppBarFarItems';
import { SkipToContentButton } from './SkipToContentButton/SkipToContentButton';
import { useAppBarColor } from './useAppBarBackgroundColor';
/** The vertical size of the Appbar component. */
export const APPBAR_HEIGHT = '48px';
/**
 * Premade top nav for MSRC's React-based portal sites.
 *
 * Also includes built in error boundary handling.
 */
export const Appbar = ({ ariaLabel, primaryGroupAriaLabel = 'Contextual menu', farItemsGroupAriaLabel = 'Utility menu', ariaLabelOverflowButton = 'More options', items = [], farItems = [], defaultMeControl = true, meControlCommandList, gearMenuItemList, isInternalPortal = false, supportEmailUrl, supportFormUrl, siteName, siteHomeHref, portalHomeHref, portalName, stringsAppBar, }) => {
    const commandBarStyles = useAppbarCommandBarStyles();
    const { background } = useAppBarColor();
    /** Re-built itemlist to avoid mutating the input */
    const nearItemListCombined = useAppBarNearItems({
        siteName,
        siteHomeHref,
        portalName,
        portalHomeHref,
        items,
    });
    /** Re-built itemlist to avoid mutating the input */
    const farItemListCombined = useAppBarFarItems({
        farItems,
        gearMenuItemList,
        isInternalPortal,
        supportFormUrl,
        stringsFarItems: stringsAppBar,
    });
    return (_jsx(AppErrorBoundary, Object.assign({ compact: true, supportEmailUrl: supportEmailUrl }, { children: _jsxs("div", Object.assign({ id: 'appbar', style: {
                alignContent: 'stretch',
                background,
                display: 'flex',
                height: APPBAR_HEIGHT,
                width: '100%',
                flexGrow: '1',
            } }, { children: [_jsxs("div", Object.assign({ style: {
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } }, { children: [_jsx(SkipToContentButton, {}), _jsx(MicrosoftLogo, {})] })), _jsx("div", Object.assign({ style: {
                        flexGrow: 8,
                        flexShrink: 1,
                        minWidth: '10em',
                        maxWidth: '92%',
                    } }, { children: _jsx(CommandBar, { overflowButtonProps: {
                            ariaLabel: ariaLabelOverflowButton,
                        }, ariaLabel: ariaLabel, farItems: farItemListCombined, items: nearItemListCombined, styles: commandBarStyles, primaryGroupAriaLabel: primaryGroupAriaLabel, farItemsGroupAriaLabel: farItemsGroupAriaLabel }) })), _jsx("div", Object.assign({ style: {
                        alignItems: 'stretch',
                        display: 'flex',
                    } }, { children: _jsx(DefaultMeControl, { defaultMeControl: defaultMeControl, meControlCommandList: meControlCommandList }) }))] })) })));
};
